/**
 * 汎用メソッドの置き場
 */
class Utility {
    /**
     * Map を値で降順にソートするユーティリティ関数
     * @param {Map} map - ソート対象の Map
     * @param {boolean} [sortByKey=false] - true にするとキーでソート
     * @returns {Map} ソートされた新しい Map
     */
    static sortMap(map, sortByKey = false) {
        return new Map(
            Array.from(map).sort((a, b) => {
                if (sortByKey) {
                    return a[0].localeCompare(b[0]); // キーで昇順ソート
                }
                return b[1] - a[1]; // 値で降順ソート
            })
        );
    }

    /**
     * 配列の平均値を計算するユーティリティ関数
     * @param {number[]} array - 平均を計算する配列
     * @returns {number} 平均値 (配列が空の場合は 0)
     */
    static calculateAverage(array) {
        if (!Array.isArray(array) || array.length === 0) {
            return 0; // 配列が空の場合は 0 を返す
        }
        const sum = array.reduce((total, num) => total + num, 0);
        return sum / array.length;
    }


    /**
     * 指定の小数点以下で四捨五入を行う関数
     * @param {number} value - 丸めたい数値
     * @param {number} decimals - 小数点以下の桁数
     * @returns {number} - 四捨五入された数値
     */
    static roundToDecimal(value, decimals) {
        const factor = Math.pow(10, decimals); // 指定した桁数に対応する倍率を計算
        return Math.round(value * factor) / factor; // 倍率を使って丸めて元のスケールに戻す
    }

    /**
     * Map を値で降順にソートするユーティリティ関数
     * @param {Map} map - ソート対象の Map
     * @param {boolean} [sortByKey=false] - true にするとキーでソート
     * @returns {Map} ソートされた新しい Map
     */
    static sortMap(map, sortByKey = false){
        return new Map(
            Array.from(map).sort((a, b) => {
                if (sortByKey) {
                    return a[0].localeCompare(b[0]); // キーで昇順ソート
                }
                return b[1] - a[1]; // 値で降順ソート
            })
        );
    };

    // 配列の合計を計算
    static sum(array) {
        return array.reduce((acc, curr) => acc + curr, 0);
    }

    // 平均
    static mean(array) {
        return Utility.sum(array) / array.length;
    }

    // 中央値
    static median(array) {
        const sorted = [...array].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        return sorted.length % 2 !== 0
            ? sorted[mid]
            : (sorted[mid - 1] + sorted[mid]) / 2;
    }

    // 最頻値
    static mode(array) {
        const frequency = {};
        array.forEach(value => frequency[value] = (frequency[value] || 0) + 1);
        const maxFreq = Math.max(...Object.values(frequency));
        return Object.keys(frequency)
            .filter(key => frequency[key] === maxFreq)
            .map(Number);
    }

    // 分散
    static variance(array) {
        const mean = Utility.mean(array);
        const squaredDiffs = array.map(value => (value - mean) ** 2);
        return Utility.mean(squaredDiffs);
    }

    // 標準偏差
    static standardDeviation(array) {
        return Math.sqrt(Utility.variance(array));
    }


    // 移動平均を計算する関数
    static calculateMovingAverage(data, windowSize) {
        console.log(data);
        const result = [];
        for (let i = 0; i < data.length; i++) {
            const start = Math.max(0, i - Math.floor(windowSize / 2));
            const end = Math.min(data.length, i + Math.ceil(windowSize / 2));
            const windowData = data.slice(start, end);
            const average = windowData.reduce((sum, val) => sum + val, 0) / windowData.length;
            result.push(average);
        }
        return result;
};
}

export default Utility;